__turbopack_context__.v({
  "largePromptButton": "UhxSection-module__Cb0qwG__largePromptButton",
  "noUhxButton": "UhxSection-module__Cb0qwG__noUhxButton",
  "sectionContainer": "UhxSection-module__Cb0qwG__sectionContainer",
  "sectionTitleRow": "UhxSection-module__Cb0qwG__sectionTitleRow",
  "uhxCard": "UhxSection-module__Cb0qwG__uhxCard",
  "uhxContentContainer": "UhxSection-module__Cb0qwG__uhxContentContainer",
});
